import React, { FunctionComponent } from "react";

import { bemClassNames } from "@multiweb/reactUtils";
import { DropdownAction, DropdownItemBaseProps } from "../../types";
import { DropdownIconText } from "../DropdownIconText";
import { DropdownItemWrapper } from "../DropdownItemWrapper";

export type DropdownItemProps = {
    /** Callback volaný na kliknutí */
    clickAction: DropdownAction;
} & Omit<DropdownItemBaseProps, "clickAction">;

const classNames = bemClassNames("dropdown-item");

export const DropdownItem: FunctionComponent<DropdownItemProps> = (({
    clickAction,
    ...restProps
}) => (
    <DropdownItemWrapper {...{ clickAction }} {...restProps}>
        <div className={classNames()}>
            <DropdownIconText iconCode={clickAction.icon} value={clickAction.text} disabled={clickAction.disabled} {...restProps} />
        </div>
    </DropdownItemWrapper>
));
